var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.503906 1.73045C0.510073 0.845905 1.22516 0.130077 2.10971 0.123047H31.2731C32.1602 0.123047 32.8789 0.843376 32.8789 1.73045V27.6531C32.8727 28.5377 32.1576 29.2535 31.2731 29.2605H2.10971C1.22263 29.2597 0.503906 28.5403 0.503906 27.6531V1.73045ZM29.6416 3.36061H3.74159V26.0231L18.783 10.9784C19.4152 10.3465 20.4398 10.3465 21.072 10.9784L29.6416 19.5643V3.36061ZM6.97872 9.83549C6.97872 11.6235 8.42819 13.073 10.2162 13.073C12.0042 13.073 13.4537 11.6235 13.4537 9.83549C13.4537 8.04746 12.0042 6.59799 10.2162 6.59799C8.42819 6.59799 6.97872 8.04746 6.97872 9.83549Z",
    fill: "#687787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.48f1a92fb2839011adc9a466630384ce.svg";
export { ForwardRef as ReactComponent };